import { Page } from '@/core/architecture'

import { ArtistStoreItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

export const ArtistStoreItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistStoreItemDetailTemplate state={state} {...actions} />
}
